import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { translations } from '../translations';
import { languages } from './languages.ts';

export const defaultLanguage = 'el';

const resources = Object.fromEntries(
  Object.entries(translations).map(([code, translation]) => [
    code,
    { translation },
  ]),
);

// Restores the visitor's stored choice; otherwise (or if the stored value is
// unsupported) the last detector falls back to the default language
const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'defaultLanguage',
  lookup: () => defaultLanguage,
});

// Registered before init so the initial language is applied too
i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

// Resources are bundled, so init completes synchronously and the first render
// is already translated
void i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      order: ['localStorage', 'defaultLanguage'],
      // Caching is done below, only for explicit choices
      caches: [],
    },
    fallbackLng: 'en',
    supportedLngs: languages.map(({ code }) => code),
    initAsync: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (languages, _namespace, key) =>
      console.warn(
        `Translation not found for key: ${key} in language: ${languages.join(', ')}`,
      ),
  });

// Registered after the (synchronous) init, so only later language changes,
// i.e. the visitor's own choices, are remembered
i18n.on('languageChanged', (language) => {
  languageDetector.cacheUserLanguage(language, ['localStorage']);
});

export { i18n };
